export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=4074c5d5d8368b5ca9a5feeee89ea821b8ca427dec&name=addToFolderEventAction!'